<template>
    <div class="scene">
        <slot></slot>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Component from 'vue-class-component'

    @Component()
    export default class Scene extends Vue {

    }
</script>
<style scoped lang="scss">

    .scene {
        height: 100vh;
        width: 100vw;
    }

</style>
